<template>
    <b-modal id="createModal" ref="modal" title="Growsafe Certificates" v-model="show" @hide="close">

        <b-table small hover stacked="md" :items="filteredData" :fields="table.fields" sort-by="name" :show-empty="true">
            <template slot="name" slot-scope="row">
                {{ row.item.first_name }} {{ row.item.last_name }}
            </template>

            <template slot="expires_on" slot-scope="row">
                <template v-if="row.item.expires_on">
                    {{ row.item.expires_on | date_format }}
                </template>
                <span v-else class="text-muted">(unknown)</span>
            </template>
            <template slot="actions" slot-scope="row">
                <a :href="row.item.certificate" :download="buildFileName(row.item)" class="btn btn-orange btn--icon"
                   v-b-tooltip="'Download Certificate'"
                   v-if="row.item.certificate">
                    <i class="zmdi zmdi-download"></i>
                </a>
                <button class="btn btn-orange btn--icon" disabled v-else>
                    <i class="zmdi zmdi-download"></i>
                </button>
            </template>
        </b-table>

        <template slot="modal-footer">
            <button class="btn btn-secondary" @click="close">
                Close
            </button>
        </template>
    </b-modal>
</template>


<script>
import listGrowsafeUsersQuery from '@views/Setup/GrowsafeManager/queryListGrowsafeUsers.graphql';

export default {
  name: 'growSafe-modal',
  apollo: {
    growsafeUsers: {
      query: listGrowsafeUsersQuery,
      update: data => data.filterGrowsafeUsers.data,
      variables() {
        return {
          input: {
            user_id: this.user.id,
          },
        };
      },
    },
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
    close: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      growsafeUsers: [],
      show: true,
      loading: 0,
    };
  },
  computed: {
    table() {
      return {
        fields: [
          { key: 'name', label: 'Name' },
          { key: 'certificate_number', label: 'Certificate' },
          { key: 'expires_on', label: 'Expiry' },
          { key: 'actions', label: '', class: 'text-right' },
        ],
      };
    },
    filteredData() {
      const fullName = (item) => `${item.first_name} ${item.last_name}`;

      return this.growsafeUsers.sort((a, b) => fullName(a).localeCompare(fullName(b)));
    },

  },
  methods: {
    buildFileName(item) {
      if (item.certificate) {
        const extension = item.certificate.substr(item.certificate.lastIndexOf('.'));
        return `${item.certificate_number}${extension}`;
      }
    },

  },
};
</script>
